// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"e98d2a72","326":"fbb5ed64","506":"66cc0dee","710":"d356926c","811":"571f3a80","821":"d77217b3"}[chunkId] + ".css";
};